import { SingleHSCodePredictions } from 'src/model/aiHSCodeLabeling';
import { TypeCountry } from "src/utils/constants/countries";
import { create } from 'zustand';
interface ISingleHSCodePrediction {
  productName: string;
  country?: TypeCountry;
  productDescription: string;
  materials: string;
  structure: string;
  usage: string;
  productionProcess: string;
  technicalSpecifications: string;
  isLoadingAIMatch: boolean;
  visiblePopupMatchAgain: boolean;
  singlePredictions: SingleHSCodePredictions;
  dispatch: (s: string | boolean | SingleHSCodePredictions | TypeCountry | any, key: keyof ISingleHSCodePrediction) => void;
  onAIMatch: (promise: Promise<SingleHSCodePredictions>) => void;
  resetStore: () => void;
  image: Blob
}

interface IBulkUploadSearchStore {
  step: number,
  file: File | null,
  dispatch: (s: ExpectedAny, key: keyof IBulkUploadSearchStore) => void
  productName: string
  productDescription: string
  columns: string[]
  fileId: string,
  fileURL: string
  visibleHistoryBulkUpload: boolean,
}

export const useSingleHSCodePredictionStore = create<ISingleHSCodePrediction>((set) => ({
  image: new Blob(),
  singlePredictions: new SingleHSCodePredictions(),
  productName: '',
  country: undefined,
  productDescription: '',
  materials: '',
  structure: '',
  usage: '',
  productionProcess: '',
  technicalSpecifications: '',
  visiblePopupMatchAgain: false,
  dispatch: (s: string | boolean | SingleHSCodePredictions | TypeCountry | any, key: keyof ISingleHSCodePrediction) => set({ [key]: s }),
  onAIMatch: async (promise: Promise<SingleHSCodePredictions>) => {
    set({ isLoadingAIMatch: true });
    const res = await promise;
    set({ singlePredictions: res, isLoadingAIMatch: false, visiblePopupMatchAgain: false });
  },
  isLoadingAIMatch: false,
  resetStore: () =>
    set({
      singlePredictions: new SingleHSCodePredictions(),
      productName: '',
      productDescription: '',
      country: undefined,
      materials: '',
      structure: '',
      usage: '',
      productionProcess: '',
      technicalSpecifications: '',
      visiblePopupMatchAgain: false,
    }),
}));

export const useBulkUploadSearchStore = create<IBulkUploadSearchStore>((set) => ({
  step: 1,
  file: null,
  dispatch: (s: ExpectedAny, key: keyof IBulkUploadSearchStore) => set({ [key]: s }),
  productName: '',
  productDescription: '',
  fileId: '',
  country: undefined,
  fileName: '',
  columns: [],
  fileURL: "",
  visibleHistoryBulkUpload: false
}))
